<template>
  <div>
    <div class="qr-code" v-if="code">
      <div class="background-color">
        <div class="qr">
            <vue-qr :text="`${codeType}${code}`" :margin="0" colorDark="#000" colorLight="#fff" :logoScale="0.1" :size="260"></vue-qr>
        </div>
        <div class="code-text">
          <p>{{code}}</p>
          <p class="text-name">{{codeName}}</p>
        </div>
      </div>
    </div> 
    <div class="qr-code" v-if="qrDataArr.length>0">
      <div class="background-color" v-for="(item,index) in qrDataArr" :key="index">
        <div class="qr">
            <vue-qr :text="`${item.codeType}${item.code}`" :margin="0" colorDark="#000" colorLight="#fff" :logoScale="0.1" :size="260"></vue-qr>
        </div>
        <div class="code-text">
          <p class="text">{{item.code}}</p>
          <p class="text name">{{item.name}}</p>
        </div>
      </div>
    </div> 
  </div>
</template>
<script>
import vueQr from 'vue-qr'
import { getLocalStorage } from "@/utils/storage";
export default {
    components: {
        vueQr
    },
    data() {
      return {
        code: '',
        codeName: '',
        codeType: '',
        qrDataArr:[]
      }
    },
  created() {
    const qrData = JSON.parse(window.localStorage.getItem('printQr'))
    const qrDataArr = JSON.parse(window.localStorage.getItem('printQrArr'))
    if(qrData&&Object.keys(qrData).length != 0) {
    this.code = qrData.code
    this.codeName = qrData.name
    this.codeType = qrData.codeType
    }else if(qrDataArr.length>0) {
      this.qrDataArr = qrDataArr
    }
    setTimeout(() => {
      window.print()
    }, 1000)
  },
}
</script>
<style lang="less">
div {
  margin: 0 auto;
}
.qr-code {
  width: 100%;
  height: 100%;
}
.background-color {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color:rgba(194, 194, 224, 0.25);
  .qr {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .code-text {
      font-size: 20px;
      margin-top: 20px;
      text-align: center;
      .text {
        width: 250px;
        word-wrap: break-word;
        word-break: normal;
      }
      .name {
        margin-top: -15px;
      }
    }
}
</style>